import { Validator } from "vee-validate";
import VeeValidateMessagesRu from "vee-validate/dist/locale/ru";
import moment from "moment";

const messages = {
  ru: {
    messages: {
      required: () => "Обязательное поле",
      alpha: () => `Поле может содержать только буквы`,
      numeric: () => `Значение поля должно быть числом`,
      confirmed: () => `Пароли не совпадают`,
      email: () => "Поле должно быть эл. почтой",

      phone: () => "Введите номер телефона",

      single_dropdown_in: () => "Выберите из списка",

      single_datepicker_date: () => "Выберите дату",

      single_datepicker_greater_or_equal: (fieldName, dateFrom) =>
        `Выберите, начиная с ${moment(dateFrom).format("DD.MM.YYYY")}`,

      single_datepicker_less_or_equal: (fieldName, dateTo) =>
        `Выберите дату до ${moment(dateTo).format("DD.MM.YYYY")}`,

      multiple_dropdown_in: () => "Выберите из списка",

      min: (field, value) => `Поле должно быть не менее ${value} символов`,
      max: (field, value) => `Поле должно быть не более ${value} символов`,

      date_format: () => "Поле должно быть в формате ДД.ММ.ГГГГ",
      check_date_format: () => "Неверная дата",

      custom_alpha: () => "Только буквы, пробел, дефис",

      digits: (field, value) =>
        `Поле должно быть числовым и точно содержать ${value} цифры`,

      min_value: (field, value) => `Минимальное значение: ${value}`,
      max_value: (field, value) => `Максимальное значение: ${value}`,

      if_digits_then_letters: () => `Не может содержать только цифры`,

      website: () => `Некорректный адрес сайта`,

      float: () => `Введите число`,

      inn: () => `Некорректный ИНН`
    }
  },

  en: {
    messages: {
      required: () => "Required",
      alpha: () => `Field must contain only letters`,
      numeric: () => `Field must contain only digits`,
      confirmed: () => `The confirmation does not match`,
      email: () => "Field must be valid e-mail",

      phone: () => "Enter phone number",

      single_dropdown_in: () => "Select from the list",

      single_datepicker_date: () => "Select a date",

      single_datepicker_greater_or_equal: (fieldName, dateFrom) =>
        `Select date from ${moment(dateFrom).format("DD.MM.YYYY")}`,

      single_datepicker_less_or_equal: (fieldName, dateTo) =>
        `Select date until ${moment(dateTo).format("DD.MM.YYYY")}`,

      multiple_dropdown_in: () => "Select from the list",

      min: (field, value) => `Must be at least ${value} characters long`,
      max: (field, value) => `Must be at max ${value} characters long`,

      date_format: () => "Must be in the format DD.MM.YYYY",
      check_date_format: () => "Incorrect date",

      custom_alpha: () => "Only letters, space or hyphen",

      digits: (field, value) =>
        `Must be numeric and be exactly ${value} digits long`,

      min_value: (field, value) => `Min value: ${value}`,
      max_value: (field, value) => `Max value: ${value}`,

      if_digits_then_letters: () => `Cannot contain only numbers`,

      website: () => `Incorrect website address`,

      float: () => `Must be a number`,

      inn: () => `Invalid INN`
    }
  }
};

export const veeValidator = () => {
  Validator.localize("ru", VeeValidateMessagesRu);

  Validator.localize(messages);

  Validator.extend("phone", {
    validate: value => /^\+\d\d+$/.test(value)
  });

  Validator.extend("single_dropdown_in", {
    validate: (value, haystack) => !!haystack.find(x => x.value === value)
  });

  Validator.extend("single_datepicker_date", {
    validate: value => moment(value).isValid()
  });

  Validator.extend("single_datepicker_greater_or_equal", {
    validate: (value, dateFrom) => {
      dateFrom = moment(dateFrom).startOf("day");
      value = moment(value, "DD.MM.YYYY").startOf("day");

      return value.diff(dateFrom) >= 0;
    }
  });

  Validator.extend("single_datepicker_less_or_equal", {
    validate: (value, dateTo) => {
      dateTo = moment(dateTo).startOf("day");
      value = moment(value, "DD.MM.YYYY").startOf("day");

      return dateTo.diff(value) >= 0;
    }
  });

  Validator.extend("multiple_dropdown_in", {
    validate: (values, haystack) => {
      if (!Array.isArray(values)) {
        return false;
      }

      for (const value of values) {
        if (value === null) {
          continue;
        }

        const option = haystack.find(x => x.value === value);

        if (!option) {
          return false;
        }
      }

      return true;
    }
  });

  // Только буквы, пробел и дефис
  Validator.extend("custom_alpha", {
    validate: value => {
      return /^[А-ЯЁа-яёA-Za-z\s\-—]+$/.test(value);
    }
  });

  // Проверяет дату
  Validator.extend("check_date_format", {
    validate: (value, mask) => {
      return moment(value, mask).isValid();
    }
  });

  // Проверяет если есть цифры, то должны быть и буквы
  Validator.extend("if_digits_then_letters", {
    validate: value => {
      return !(/[0-9]+/.test(value) && !/[а-яёА-ЯЁa-zA-Z]+/.test(value));
    }
  });

  Validator.extend("float", {
    validate: value => !isNaN(Number(value))
  });

  Validator.extend("website", {
    validate: value => {
      if (!/^[a-zа-я0-9\-./:_]+$/gi.test(value)) {
        return false;
      }

      const firstPeriodIndex = value.indexOf(".");

      return !(
        firstPeriodIndex === -1 || value.length - 1 === firstPeriodIndex
      );
    }
  });

  Validator.extend("inn", {
    validate: value => {
      const innMinLength = 10,
        isNum = /^\d+$/.test(value);

      return !!(value && isNum && value.length >= innMinLength);
    }
  });
};
